import merge from 'lodash/merge';
import {ThemeBuildType, ThemeVariablesType} from '@yosmanyga/theme';

const buildTheme = (
    variables: ThemeVariablesType | undefined,
    prev?: ThemeBuildType
) => {
    const local = {
        text: {
            // This doesn't work anymore, because onClick was removed from styleFields
            // has_onClick: {
            //   cursor: 'pointer',
            // },
        },
        anchor: buildAnchor(),
        button: buildButton(),
        button_progress: buildButtonProgress(),
        container: buildContainer(),
    };

    return merge(
        {},
        prev ? prev(variables) : {},
        local
    );
};

const buildAnchor = () => {
    const button = buildButton();

    return {
        ...button,
        cursor: 'pointer',
        decoration: {
            line: 'none',
        },
        is_disabled: {
            cursor: 'not-allowed',
        },
    };
};

const buildButton = () => {
    return {
        is_disabled: {
            cursor: 'not-allowed',
        },
    }
}

const buildButtonProgress = () => {
    return {
        position: {
            type: 'absolute',
            top: '50%',
            left: '50%'
        },
    };
};

const buildContainer = () => {
    return {
        button_intent: {
            cursor: 'pointer',
        },
    }
}

export {
    buildTheme
};